import React, { useState } from "react";
import { Tooltip } from "reactstrap";

interface Props {
  contractDetails: any;
  monthName: string;
  negotiationContractDraftHandler: (Id: string) => void;
}

const NegotiationContractTile = ({
  contractDetails,
  monthName,
  negotiationContractDraftHandler,
}: Props) => {
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);
  // toggle handler for tooltip with different target id 
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const targetId = `tooltip-negotiation-tile-user-name-${contractDetails.id}`;

  // Extracted className logic
  let statusClassName = "negotiation-tile-in-review";
  if (contractDetails.isSavedForLater) {
    statusClassName = "negotiation-tile-draft";
  } else if (contractDetails.status === "Completed") {
    statusClassName = "negotiation-tile-completed";
  } else if (contractDetails.status === "In Progress") {
    statusClassName = "negotiation-tile-inprogress";
  }

  // Extracted round name display logic
  let roundNameDisplay = "";
  if (contractDetails.isSavedForLater) {
    roundNameDisplay = contractDetails.roundName;
  } else if (
    contractDetails.status === "Completed" ||
    contractDetails.status === "In Review"
  ) {
    roundNameDisplay = contractDetails.roundName;
  } else {
    roundNameDisplay = `Current Phase: ${contractDetails.roundName}`;
  }

  return (
    <div className="col-lg-3 col-md-6">
      <div
        className="negotiation-tile-box"
        onClick={() => negotiationContractDraftHandler(contractDetails)}
        role="button"
      >
        <div className="negotiation-tile-status">
          <span
            className={statusClassName}
          >
            {contractDetails.isSavedForLater
              ? "Draft"
              : contractDetails.status}
          </span>
        </div>
        <div className="negotiation-tile-header-box">
          <div className="negotiation-tile-title">
            {contractDetails.negotiationName}
          </div>
          <div className="negotiation-tile-company-name">
            {contractDetails.supplierName}
            <br />{contractDetails.categoryName}
          </div>
        </div>
        <div className="row negotiation-tile-profile">
          <div className="col-4 alignment-center-style">
            <div className="negotiation-tile-profile-logo alignment-center-style">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="#004A96"
                className="bi bi-person"
                viewBox="0 0 16 16"
              >
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
              </svg>
            </div>
          </div>
          <div className="col-8">
            <div className="negotiation-tile-lead">Sales Rep Lead</div>
            <div className="negotiation-tile-user-name" id={targetId}>
              {contractDetails.salesRepLeadName}
              <Tooltip
                placement={"top"}
                isOpen={tooltipOpen}
                target={targetId}
                toggle={toggle}
                className="custom-tooltip-negotiation-tile"
              >
                <div className="negotiation-tile-email">
                  Email: {contractDetails.salesRepLeadEmailAddress}
                </div>
                <div className="negotiation-tile-email">
                  Phone no: {contractDetails.salesRepLeadMobileNumber}
                </div>
              </Tooltip>
            </div>
            <div className="negotiation-tile-classification-type">
              {contractDetails.salesRepClassificationTitle}
            </div>
          </div>
        </div>
        <div className="negatiation-tile-start-date">
          {" "}
          Negotiation Date :{" "}
          {`${monthName} ${contractDetails.negotiationDateYear
            ? contractDetails.negotiationDateYear
            : ""
            }`}
        </div>
        <div className="negotiation-tile-round-box">
          <div className="row alignment-center-style">
            <div className="col-2">
              <div className="negotiation-tile-calender-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#004A96"
                  className="bi bi-calendar3 negotiation-tile-calender-logo"
                  viewBox="0 0 16 16"
                >
                  <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                  <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                </svg>
              </div>
            </div>
            <div className="col-10">
              <div className="negotiation-tile-round-name">
                {roundNameDisplay}
              </div>
            </div>
          </div>
        </div>
        <div className="negotiation-tile-spend">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#004A96"
            className="bi bi-wallet2 negotiation-tile-spend-icon"
            viewBox="0 0 16 16"
          >
            <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" />
          </svg>
          Relevant spend
        </div>
        <div className="negotiation-tile-spend-amount">
          {contractDetails.formatedRelevantSpend}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#000"
            className="bi bi-currency-euro negotiation-tile-spend-amount-logo"
            viewBox="0 0 16 16"
          >
            <path d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936q-.002-.165.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.6 6.6 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default NegotiationContractTile;
